//请自行添加语言资源
const reshipCornPlan = {
  planNo:"计划单号",
  plantName:'基地',
  planStatusName:'计划状态',
  goodsCategoryName:'货物类型',
  storageName:'发出库位',
  loadingTypeName: '装货类型',
  businessTypeName: '倒运类型',
  planLotNo: '批次',
  createTime: '创建时间',
  planWeight: '计划倒运量',
  schNo:'车辆调度单',
  schStatusName:'调度状态',
  orderNo: '厂内倒运作业单号',
  vehicleNo: '车牌号',
  driverTel: '手机号',
  driverUserNo: '司机用户',
  destStorageName: '收货库位名称',
  reshipCornOrderStatus: '运作单状态',
  msg:{
  }
};
export default reshipCornPlan



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlan/lang/reshipCornPlan.zh.js